import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=47e0e400"
import script from "./Acciones.vue?vue&type=script&lang=js"
export * from "./Acciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e0e400')) {
      api.createRecord('47e0e400', component.options)
    } else {
      api.reload('47e0e400', component.options)
    }
    module.hot.accept("./Acciones.vue?vue&type=template&id=47e0e400", function () {
      api.rerender('47e0e400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documento/Acciones.vue"
export default component.exports